import axios from 'axios';

const BASE_URL = 'https://onboarding.aethyra.cloud/backend/api.php';

// Function to save agent information
export const saveAgentInfo = (formData) => {
  // Creating a new FormData object to send the data, including the file upload
  const formDataToSubmit = new FormData();

  // Append action name for backend identification
  formDataToSubmit.append('action', 'save_agent_info');

  // Append form data fields
  formDataToSubmit.append('name', formData.name);
  formDataToSubmit.append('mlsNumber', formData.mlsNumber);
  formDataToSubmit.append('nrdsNumber', formData.nrdsNumber);
  formDataToSubmit.append('licenseNumber', formData.licenseNumber);
  formDataToSubmit.append('shortBio', formData.shortBio);
  formDataToSubmit.append('longBio', formData.longBio);

  // Append headshot if it exists
  if (formData.headshot) {
    formDataToSubmit.append('headshot', formData.headshot);
  }

  // Make the axios request
  return axios.post(BASE_URL, formDataToSubmit, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

// Function to save tasks for an agent
export const saveTasks = (agentId, tasks) => {
  // Creating a JSON payload to save tasks
  return axios.post(BASE_URL, {
    action: 'save_tasks',
    agentId,
    tasks,
  });
};
